import { isAfter, parseISO } from 'date-fns';
import { isString } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';

const useTimer = ({ endAt = null, onEnd: parentOnEnd = null }) => {
    const initialEnded = useMemo(() => {
        const stringDate = endAt !== null && isString(endAt) ? endAt : null;
        const dateDate = endAt !== null && typeof endAt === 'object' ? endAt : null;
        const endDate = stringDate !== null ? parseISO(stringDate) : dateDate;
        return endDate !== null && isAfter(new Date(), endDate);
    }, [endAt]);

    const [ended, setEnded] = useState(initialEnded);
    const onEnded = useCallback(
        (dateValue = null) => {
            if (dateValue !== null) {
                setEnded(true);
                if (parentOnEnd !== null) {
                    parentOnEnd(true);
                }
            }
        },
        [setEnded, parentOnEnd],
    );

    useEffect(() => {
        setEnded(initialEnded);
        if (parentOnEnd !== null && initialEnded) {
            parentOnEnd(initialEnded);
        }
    }, [initialEnded, endAt, setEnded, parentOnEnd]);

    return {
        onEnded,
        ended,
        started: endAt !== null,
    };
};

export default useTimer;
